import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

export default function Edit({ attributes, setAttributes }) {
  return (
    <div {...useBlockProps()}>
                    <h3>{__('Monfort Testimonial Slider')}</h3>
                    <p>{__('Preview not generated for dynamic blocks.', 'monfort')}</p>
                </div>
  );
}
